import styled from 'styled-components';

export const StyledForm = styled.form`
    max-width: 480px;
    min-height: 530px;  
    background-color: white;  
    margin: 0 auto;
    border: 1px solid black;  
    border-radius: 10px; 
    margin-top: 30px;
    position: relative;
    padding: 10px;
    padding-bottom: 20px;
    
    @media (max-width: 480px) {
        transform: scale(0.95);
    }
`;

export const FormHeader = styled.p`
    display: inline-block;
    font-size: 20px;
    color: black;
    font-family: Roboto Condensed, serif; 
    margin-left: 20px;
    margin-top: 50px;
    font-weight: bold;
`;

export const FormSubheader = styled.p`
    display: inline-block;
    font-size: 11px;
    color: gray;
    font-family: Roboto Condensed, serif; 
    margin-top: 20px;
    margin-right: 20px;
`;

export const ColoredStatus = styled.span`
    color: ${({color}) => color};
    font-weight: bold;
`;

export const FormContent = styled.div`
    margin-left: 20px;
`;

export const StyledRow = styled.div`
    display: flex;
    flex-direction: ${({flexDirection}) => flexDirection ?? 'row'};
    align-items: start;
`;

export const FileInput = styled.input``

export const ImgPreviewContainer = styled.div`
    width: 90%;
    display: flex;
    flex-wrap: wrap;
`;

export const ImgPreview = styled.img`
    width: 125px;
    height: 125px;
    border: 1px solid black;
`;

export const ImgPreviewDiv = styled.div`
    width: 125px;
    height: 125px;
    margin: 5px;
    position: relative;
`;

export const FormLabel = styled.label`
    font-size: 15px;
    color: black;
    font-family: Roboto Condensed, serif;
    margin-right: 15px;
    margin-top: 10px;
`;

export const FormInput = styled.input`
    height: 20px;
    margin-right: 20px;
    margin-top: 5px;
    border: 0;
    border-bottom: 1px solid black;
    font-size: 14px;
    color: black;
    font-family: Roboto Condensed, serif;
    width: ${({width}) => width ?? '70%'};
    outline: none;
    
    &:focus {
        border-bottom: 1px solid orange;
    }
`;

export const FormSelect = styled.select`
    font-family: ${({fontFamily}) => fontFamily ?? 'Roboto Condensed'}, serif;
    margin-top: 10px;
`;

export const StyledOption = styled.option``;

export const FormButton = styled.button`
    background-color: transparent;
    cursor: pointer;
    color: ${({color}) => color ?? 'black'};
    font-family: BlenderProBold, serif;
    font-size: 13px;    
    letter-spacing: 1px;
    font-weight: 400;
    text-decoration: none;
    width: 100px;
    margin: 5px;
    text-align: center;
    text-transform: uppercase;
    text-decoration: none;
    padding: 5px;
    border: 1px solid ${({butType}) => butType === 'clear' ? 'red' : 'orange'};    
    border-radius: 5px;
    transition: 2s all;
    
    &:hover {
        color: black;
        background-color: ${({butType}) => butType === 'clear' ? 'red' : 'orange'}; 
        border: 1px solid black;    
    }
    
    &:disabled {
        cursor: not-allowed;
    }
`;

export const ButtonsContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    margin-top: 30px;
    margin-right: 30px;
`;

export const StyledTextArea = styled.textarea`
    width: 90%;
    margin-top: 5px;
    height: ${({height}) => height ?? '300px'};
    outline: none;
    font-family: Roboto Condensed, serif;
    font-weight: 300;
    font-size: 14px;
    resize: none;
    
    &:focus {
        border: 1px solid orange;
    }
`;

export const StyledInputRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
`;

export const StyledButton = styled.button`
    cursor: pointer;
    margin-top: 10px;
    width: 20px;
`;
